import { useEffect } from 'react'

const useIntersectionObserver = ({ target, onIntersect, threshold = 0.1, rootMargin = '0px' }) => {
    const canIntersect = 'IntersectionObserver' in window

    useEffect(() => {
        if (canIntersect) {
            const observer = new IntersectionObserver(onIntersect, {
                rootMargin,
                threshold,
            })

            const current = target.current

            observer.observe(current)

            return () => observer.unobserve(current)
        }
    }, [canIntersect, onIntersect, rootMargin, target, threshold])

    return canIntersect
}

export default useIntersectionObserver
